export var localeDropdownMenu = [{
  value: 'en-US',
  label: 'English'
}, {
  value: 'fr',
  label: 'French (Français)'
}, {
  value: 'de',
  label: 'German (Deutsch)'
}, {
  value: 'it',
  label: 'Italian (Italiano)'
}, {
  value: 'es-ES',
  label: 'Spanish (Español)'
}, {
  value: 'nl',
  label: 'Dutch (Nederlands)'
}, {
  value: 'ja',
  label: 'Japanese (日本語)'
}, {
  value: 'cs',
  label: 'Czech (Čeština)'
}, {
  value: 'da',
  label: 'Danish (Dansk)'
}, {
  value: 'el',
  label: 'Greek (ελληνικά)'
}, {
  value: 'hr',
  label: 'Croatian (Hrvatski jezik)'
}, {
  value: 'hu',
  label: 'Hungarian (Magyar)'
}, {
  value: 'pl',
  label: 'Polish (Polszczyzna)'
}, {
  value: 'ru',
  label: 'Russian (русский)'
}, {
  value: 'sk',
  label: 'Slovak (Slovenčina)'
}, {
  value: 'pt-BR',
  label: 'Portuguese Brazil (Português)'
}, {
  value: 'zh-CN',
  label: 'Chinese (简体中文)'
}];
export var currencyTypes = ['EUR', 'USD', 'GBP', 'ILS', 'KRW', 'JPY', 'HKD', 'BRL', 'CZK', 'CNY', 'NGN', 'PHP', 'RUB', 'PLN', 'PYG', 'THB', 'UAH', 'VND', 'TRY', 'AFN', 'AED', 'SAR', 'BGN', 'IDR', 'ARS', 'CLP', 'COP', 'NZD', 'SGD', 'AUD', 'JMD', 'INR', 'TWD', 'MXN', 'CAD', 'HRK', 'SEK', 'RON', 'DKK', 'NOK', 'CHF', 'HUF', 'MYR', 'ZAR', 'PEN', 'MAD', 'CRC'];
export var currencyIdsMap = new Map(currencyTypes.map(function (currency) {
  var curr = currency.toLowerCase();
  return [curr, "common:formatted_currency.".concat(curr)];
}));
export var dateIdsMap = new Map([['short', 'common:formatted_date.short'], ['medium', 'common:formatted_date.medium'], ['long', 'common:formatted_date.long'], ['full', 'common:formatted_date.full']]);
export var timeIdsMap = new Map([['short', 'common:formatted_time.short'], ['medium', 'common:formatted_time.medium'], ['long', 'common:formatted_time.long'], ['full', 'common:formatted_time.full']]);
export var MomentFormatTypes;

(function (MomentFormatTypes) {
  MomentFormatTypes["ShortDate"] = "shortDate";
  MomentFormatTypes["FullDate"] = "fullDate";
  MomentFormatTypes["Date"] = "date";
  MomentFormatTypes["MMMM_YYYY"] = "mmmm yyyy";
  MomentFormatTypes["MMMM"] = "mmmm";
  MomentFormatTypes["YYYY"] = "yyyy";
  MomentFormatTypes["MMM_YYYY"] = "mmm yyyy";
  MomentFormatTypes["ShortMonthYear"] = "mmm yy";
  MomentFormatTypes["Time"] = "time";
})(MomentFormatTypes || (MomentFormatTypes = {}));